import React from 'react';
import ServicePageLayout from './service/ServicePageLayout';
import dataQualityPageData from '../data/servicePages/dataQuality';

const DataQualityPage = () => <ServicePageLayout data={dataQualityPageData} />;

export default DataQualityPage;
